import React from 'react';
import { DEFAULT_SCOPE_COLOR } from '../../extensions/bundled/documents/documentsScopes';
import { DeviceGlyph } from './treeIcons';
import { workspaceGlyph } from './workspaceIcons';
import { initialOf } from './scopeChoices';

/**
 * The 20 px chip in front of a tree's name (header, switcher rows, Manage
 * workspaces): a workspace's icon on its colour, the user's / team's initial,
 * or a device glyph for This device. `size` scales the box for the modal
 * preview; the glyph follows.
 */
export default function WorkspaceChip({ choice, userName, size = 20 }) {
  const box = size === 20 ? undefined : { width: size, height: size, borderRadius: Math.round(size * 0.3) };
  if (choice.kind === 'device') {
    return (
      <span className="doc-scope-chip doc-scope-chip--device" style={box}>
        <DeviceGlyph size={12} />
      </span>
    );
  }
  if (choice.kind === 'workspace') {
    const Glyph = workspaceGlyph(choice.icon);
    return (
      <span
        className="doc-scope-chip doc-scope-chip--workspace"
        style={{ ...box, background: choice.color || DEFAULT_SCOPE_COLOR }}
        data-testid="doc-workspace-chip"
      >
        <Glyph size={Math.round(size * 0.6)} strokeWidth={2} aria-hidden />
      </span>
    );
  }
  const name = choice.kind === 'personal' ? userName || choice.label : choice.label;
  return (
    <span className={`doc-scope-chip doc-scope-chip--${choice.kind}`} style={box}>
      {initialOf(name)}
    </span>
  );
}
